import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {injectIntl, defineMessages, IntlShape} from 'react-intl';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import types from '../../common/model-api/types';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import LoggerView from '../loggers/LoggerView.react';
import { User } from '../../common/types/types';

const messages = defineMessages({
    title: {id: 'logger.title', 'defaultMessage': 'Logger'},
});

interface ChannelLoggerProps {
    intl: IntlShape;
    relay: object;
    user: User;
}

class ChannelLogger extends React.Component<ChannelLoggerProps> {

    typeName = 'channels';

    constructor(props) {
        super(props);
    }

    static propTypes = {
        intl: PropTypes.object.isRequired,
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired,
    };

    render() {
        let { user } = this.props;
        let { channel } = user.organisation;

        let type = types[this.typeName];

        return (
            <AppPanel breadcrumbParams={[
                {type, data: channel},
                {type: types['organisations'], data: this.props.user.organisation},
            ]} title={this.props.intl.formatMessage(messages.title)}>
                <LoggerView logger={channel.logger} />
            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(injectIntl(ChannelLogger), (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
			variables.organisationId = getLastOrganisationId();
		}

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    channel(id: $channelId) {
                        id,
                        organisation_id,
                        channelDef {
                            id,
                            name,
                            icon
                        },
                        type,
                        cachingStatus,
                        name,
                        description,
                        enabled
                        logger(first: 100) {
                            ${LoggerView.getFragment('logger')}
                        }
                    }
                }
            }
        `,
    },
});
